import styled from 'styled-components';

export const Header = styled.header`
  justify-content: flex-end;
  align-items: center;
  margin-right: 20px;
  padding-top: 10px;
  display: flex;

  & > div {
    margin-left: 20px;
  }
`;
